module.exports = __webpack_public_path__ + "media/images/home/ic_delete-64e6d358ac5c807ce68d3628af20c721.svg";